import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpEngagementRateKeys = {
  all: ['analytics', 'fp-engagement-rate'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpEngagementRateKeys.all, 'list', params] as const,
};

export const useFPEngagementRateData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpEngagementRateKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPEngagementRateTrend(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
